import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchAllEventCategories } from "../Apiservices/Auth/servers/fetchCategoryEvents";
import { useTransition } from "react";
import "../redesign/css/Home.css";

function MiddleContent() {
  const [eventCategories, setEventCategories] = useState([]);
  const [isPending, startTransition] = useTransition();

  const loadEventCategories = async () => {
    startTransition(async () => {
      const response = await fetchAllEventCategories();
      if (response) {
        setEventCategories(response);
      }
    });
  };

  useEffect(() => {
    loadEventCategories();
  }, []);

  return (
    <div className="middle-content">
      <div className="event-tabs-wrapper" style={{ background: "transparent", paddingTop: 0, paddingBottom: 0 }}>
        <div style={{ width: "100%" }}>
          {/* Heading — matches homepage style */}
          <div className="th-section__container" style={{ marginBottom: "32px", textAlign: "center" }}>
            <span className="th-hero__text th-hero__text__title th-hero__text__sub" style={{ display: "block", textAlign: "center", width: "100%" }}>
              Don't Remember Or Not Sure What That Event Is Called?
              <br />
              <span className="th-hero__text__subtitle" style={{ display: "inline" }}>
                Find It From The Category Below
              </span>
            </span>
          </div>

          {/* 4-column card grid — same as homepage */}
          {isPending ? (
            <h3 style={{ textAlign: "center" }}>
              <i
                className="pi pi-spin pi-spinner-dotted"
                style={{ fontSize: "2rem", color: "#0cc0df" }}
              ></i>
            </h3>
          ) : (
            <div className="th-section__ev__category__container">
              {eventCategories?.map((item) => (
                <Link
                  key={item.id}
                  className="th-section__ev__category__item"
                  style={{ textDecoration: "none" }}
                  to={`/event/${item.name
                    ?.toLowerCase()
                    ?.replaceAll(" ", "-")}`}
                >
                  <span className="th-plan__text th-line__height">
                    {item.name}
                  </span>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MiddleContent;
